export const environment = {
  production: false,
  baseUrl: 'https://pr-2690-api.dev.thportal.ca/api/v1/',
  baseUrlV2: 'https://pr-2690-api.dev.thportal.ca/api/v2',
  baseURLChatbot: 'http://localhost:8000/',
  signalRActivityHubUrl: 'https://pr-2690-api.dev.thportal.ca/user-activity-tracker-hub',
  // New realtime layer, independent of the two signalR hubs above.
  realtimeHubUrl: 'https://pr-2690-api.dev.thportal.ca/realtime-hub',
  realtimeEnabled: true,
  paginationSize: 1000,
  fileFormat:
    '.png, .jpg, .jpeg, .pdf, .xlsx, .docx, .doc, .csv, .mp4, .zip, .rvt, .rfa, .rte, .rft, .dwg, .dxf, .dwt, .dgn, .step, .stp, .iges, .igs, .sat, .3dm, .sldprt, .sldasm, .ipt, .iam, .ifc, .stl, .obj',
  basicFiles: ['png', 'jpg', 'jpeg', 'pdf', 'xlsx', 'docx', 'doc', 'csv', 'mp4', 'zip'],
  revitFiles: ['rvt', 'rfa', 'rte', 'rft'],
  cadFiles: [
    'dwg',
    'dxf',
    'dwt',
    'dgn',
    'step',
    'stp',
    'iges',
    'igs',
    'sat',
    '3dm',
    'sldprt',
    'sldasm',
    'ipt',
    'iam',
    'ifc',
    'stl',
    'obj'
  ],
  templateId: 'fb9a453d-3879-43f8-89b2-b1f15d5f24fb',
  frontendUrl: 'https://pr-2690.dev.thportal.ca',
  crmUrl: 'https://staging.crm.thportal.ca',
  s3PublicUrl: 'filemanager-bucket-public.s3.ca-central-1',
  s3Url: 'filemanager-bucket-staging.s3.ca-central-1',
  qrCodeUrl: 'https://pr-2690.dev.thportal.ca/',
  recaptchaSiteKey: '6LfU3aMrAAAAACw0kXOaCgdlU1EMHk8Q6SoSbjd0',
  appName: 'erp',
  pageDataRefreshIntervalMs: 59 * 60 * 1000,
  projectExecutiveNameForDocumentSigning: 'Nicholas Fidei',
  executiveUserRoleId: 'e9f8a7b6-c5d4-4e3f-2a1b-0c9d8e7f6a5b',
  depositTypeId: '323c024d-ea1a-4a56-bc95-7c2c1d45f7c0',
  posthogKey: '',
  posthogHost: '',
  analyticsEnvironment: 'staging'
};
